import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'evento-page',
  templateUrl: './evento-page.component.html',
  styleUrls: ['./evento-page.component.scss']
})
export class EventoPageComponent implements OnInit {

  public loader   = false;
  public apelido  = null;
  public response = {
    data: null,
    status: null
  }
  public data:any = {};

  constructor(
    private app: AppService,
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ){

    let params:any = this.route.params;
    this.apelido   = params['_value'].apelido || null;

  }
  /**
   * 
   * Get data
   * 
   * 
   */
  getData(){

    try{

      this.loader = true;

      this.api.evento().show(this.apelido).subscribe((response:any) => {

        this.loader = false;

        if(response.status == 1){
          
          this.data = response.data;

          if(this.data == null){
            this.router.navigateByUrl("/");
          }

          this.response = {
            data: response.data,
            status: 1
          }

        }else{

          this.response = {
            data: response.data,
            status: 500
          }

        }


      },(response:any) => {

        this.loader = false;

        this.response = {
          data: response.data,
          status: 500
        }

      });

    }catch(e){

      this.loader = false;
      this.response = {
        data: e.message,
        status: 500
      }      

    }

  }
  /**
   * 
   * Init
   * 
   ***/
  ngOnInit():void{

    this.getData();

  }

}
